
// © Microsoft Corporation. All rights reserved.

declare global {
    interface Window {
        ReactNativeWebView: any;
    }
}

function sendBridgeEvent(bridgeEventName, data: any = {}) {
    try {
        data = {
            type: bridgeEventName,
            ...data
        };
        window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify({type: "community", data: data}));
    } catch (e) {
        // suppress error
    }
}

const lockTouch = () => sendBridgeEvent("lock-touch");
const unlockTouch = () => sendBridgeEvent("unlock-touch");

export {lockTouch, unlockTouch};